import { NavLink } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// iOS RestaurantSidebar: collapsible side panel for large screens.
// Collapsed shows icons only (with a red dot for badges), mirroring the
// admin sidebar. Tapping an item navigates to that section's root route.
export default function RestaurantSidebar({ tabs, collapsed, onToggle, businessName = 'My Business' }) {
  return (
    <aside
      className={`hidden lg:flex flex-col shrink-0 sticky top-0 h-screen bg-white border-r border-gray-200 shadow-[2px_0_10px_rgba(0,0,0,0.06)] transition-[width] duration-200 ${
        collapsed ? 'w-[70px]' : 'w-52'
      }`}
    >
      {/* Header with collapse button */}
      <div
        className={`flex items-center py-4 bg-gradient-to-b from-red-500/10 to-transparent border-b border-gray-200 ${
          collapsed ? 'justify-center px-2' : 'justify-between px-4'
        }`}
      >
        {!collapsed && (
          <div className="min-w-0">
            <p className="text-base font-bold text-gray-900 leading-tight truncate">{businessName}</p>
            <p className="text-xs font-bold text-gray-500">CheF SKN</p>
          </div>
        )}
        <button
          type="button"
          onClick={onToggle}
          className="flex flex-col items-center justify-center gap-0.5 text-red-600 hover:text-red-700 shrink-0"
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
          <span className="text-[9px] font-semibold leading-none">{collapsed ? 'Expand' : 'Collapse'}</span>
        </button>
      </div>

      {/* Tab items */}
      <nav className="flex-1 overflow-y-auto px-2 py-3 space-y-1">
        {tabs.map(({ to, label, Icon, badge }) => (
          <NavLink
            key={to}
            to={to}
            title={collapsed ? label : undefined}
            className={({ isActive }) =>
              `relative flex items-center rounded-xl border font-medium transition-colors ${
                collapsed ? 'justify-center px-0 py-3.5' : 'gap-3 px-3.5 py-3'
              } ${
                isActive
                  ? 'bg-gradient-to-r from-red-600 to-red-500 text-white border-transparent shadow-[0_4px_10px_rgba(220,38,38,0.3)]'
                  : 'text-gray-800 border-gray-100 hover:bg-gray-100'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={collapsed ? 22 : 20}
                  className={isActive ? 'text-white shrink-0' : 'text-red-600 shrink-0'}
                />
                {!collapsed && (
                  <span className={`flex-1 truncate text-base ${isActive ? 'font-semibold' : ''}`}>
                    {label}
                  </span>
                )}
                {!collapsed && badge > 0 && (
                  <span
                    className={`text-[11px] font-bold text-white px-1.5 py-0.5 rounded-full ${
                      isActive ? 'bg-white/30' : 'bg-red-500'
                    }`}
                  >
                    {badge}
                  </span>
                )}
                {collapsed && badge > 0 && (
                  <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
